export default __webpack_public_path__ + "static/media/success.8fb27628.png";